import { render, staticRenderFns } from "./YhcTpl.vue.js?vue&type=template&id=9f878316&scoped=true!=!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcTpl.vue?vue&type=template&id=9f878316&scoped=true"
import script from "./YhcTpl.vue.js?vue&type=script&lang=js!=!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcTpl.vue?vue&type=script&lang=js"
export * from "./YhcTpl.vue.js?vue&type=script&lang=js!=!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcTpl.vue?vue&type=script&lang=js"
import style0 from "./YhcTpl.vue.scss?vue&type=style&index=0&id=9f878316&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true!=!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/index.js??vue-loader-options!./YhcTpl.vue?vue&type=style&index=0&id=9f878316&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8aae61ef0cae339ad0ede0f22a11a7a2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f878316",
  null
  
)

export default component.exports